"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.PaymentDetailsWrapper=exports.PaymentDetailsTable=void 0;const PaymentDetailsWrapper=exports.PaymentDetailsWrapper=_styledComponents.default.div`
  margin: 1rem auto;
`,PaymentDetailsTable=exports.PaymentDetailsTable=_styledComponents.default.table`
  border: none;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  table-layout: fixed;
  width: 100%;

  th,
  td {
    font-size: 16px;
    line-height: 22px;
  }

  td:first-child {
    padding: 0.375rem 0 0.375rem 1rem;
  }

  td:last-child {
    text-align: right;
    padding-right: 1.5rem;
  }
`;